import { ReactNode } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { BillingBanner } from './BillingBanner';
import { SessionNoticeBanner } from './SessionNoticeBanner';
import { AppAnnouncementBanner } from './AppAnnouncementBanner';
import { CookieConsentBanner } from './CookieConsentBanner';
import { useCookieConsent } from '../lib/CookieConsentContext';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { status } = useCookieConsent();
  const cookieBannerOpen = status === 'unknown';

  return (
    <div className="flex min-h-screen flex-col">
      <a href="#main-content" className="skip-to-main print:hidden">
        Naar hoofdinhoud
      </a>
      <Header />
      <AppAnnouncementBanner />
      <SessionNoticeBanner />
      <BillingBanner />
      <main
        id="main-content"
        tabIndex={-1}
        className={`mx-auto w-full max-w-6xl flex-1 px-4 py-6 outline-none focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 sm:px-6 ${cookieBannerOpen ? 'pb-40 sm:pb-36' : ''}`}
      >
        {children}
      </main>
      <Footer />
      <CookieConsentBanner />
    </div>
  );
}
